import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { FILTER_URL_KEYS, filtersFromSearch, filtersToSearch } from './filters-model'

// The audit filters held in the URL: [filters, setFilters]. The query string
// is the only state, so a reload, a copied link and back/forward all give
// the same view. A filter change replaces the current entry (ticking a box
// doesn't add history); pass { push: true } for a pivot, which back undoes.
// The page's own parameters (?view=table) are kept; unreadable values are
// dropped by filtersFromSearch and left out of the next URL.
// defaults (a constant): the page's own toggle defaults (filtersToSearch).
// drop: a test for page parameters to leave out of the next URL (a pivot
// from Insights drops ?view=insights, and the Insights grid's own keys, in
// the same history entry as the filter change). set: page parameters to
// set ({ was: '…' }) or remove ({ was: null }) in the same entry.
export const useFiltersInURL = defaults => {
  const location = useLocation()
  const history = useHistory()
  const filters = useMemo(() => filtersFromSearch(location.search, defaults), [location.search, defaults])

  const setFilters = useCallback(
    (next, { push = false, drop, set } = {}) => {
      const out = new URLSearchParams()
      new URLSearchParams(location.search).forEach((v, k) => {
        if (!FILTER_URL_KEYS.includes(k) && !(drop && drop(k)) && !(set && k in set)) out.append(k, v)
      })
      Object.entries(set || {}).forEach(([k, v]) => {
        if (v != null && v !== '') out.append(k, v)
      })
      new URLSearchParams(filtersToSearch(next, defaults)).forEach((v, k) => out.append(k, v))
      const rest = out.toString()
      const search = rest ? `?${rest}` : ''
      if (search === location.search) return
      history[push ? 'push' : 'replace']({ pathname: location.pathname, search, state: location.state })
    },
    [history, location.pathname, location.search, location.state, defaults]
  )

  return [filters, setFilters]
}
